import React, { useMemo, useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { Panel } from "components/organisms/panel"
import { BaseTable } from "components/molecules/table"
import MiddleChart from "components/molecules/chart/middleChart"
import { NewsList } from "components/organisms/panel/newsList"
import { tableColumns } from "config/table_columns"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"
import { isEmpty, findKey, get } from "lodash"
import uuid from "uuid"
import { ROUTE_LIST } from "config/const"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { InstrumentDisclaimerText } from "config/disclaimerText"

type Props = {
  commodityData: Array<object> | []
  transitionData: object
  setRefreshFlag: Function
}

export const InstrumentTemplate = (props: Props) => {
  const [currentPosition, changePosition] = useState<number>(0)
  const [checkTransitionData, setCheckTransitionData] = useState(false)
  const [newsEffect, setNewsEffect] = useState(false)

  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  const dispatch = useDispatch()
  const isSP = checkIsSp()

  useEffect(() => {
    if (isEmpty(props.commodityData)) return
    if (props.transitionData && !checkTransitionData) {
      const activePosition = findKey(props.commodityData, (row: object) => {
        const symbol = get(props.transitionData, "Symbol")
        return get(row, "Symbol") === symbol
      })
      changePosition(Number(activePosition))
      dispatch(changeSymbol(canvasId, props.transitionData))
      setCheckTransitionData(true)
    } else {
      dispatch(changeSymbol(canvasId, props.commodityData[0]))
    }
  }, [props.commodityData])

  return (
    <MainContainer className="top-instrument-template">
      <div className="symmetry-layout top-instrument">
        <div className="contents-block">
          <Panel
            title=""
            className="panel-instrument"
            nonePanelHeader={true}
            // refresh={() => {
            //   props.setRefreshFlag(true)
            //   setNewsEffect(true)
            // }}
          >
            <div className="result-list-block">
              <BaseTable
                className="table-list-view table-liquid-cell"
                list={tableColumns.instrument.top}
                data={props.commodityData}
                active={currentPosition}
                onClick={(data: any, i: number) => {
                  isSP
                    ? dispatch(changeSpModalSymbol(data))
                    : dispatch(changeSymbol(canvasId, data))
                  changePosition(i)
                }}
              />
            </div>
          </Panel>
        </div>
        <div className="contents-block">
          <div className="contents-nest-block">
            {!isSP && (
              <Panel className="panel-list" title="" nonePanelHeader={true}>
                <MiddleChart id={canvasId} />
              </Panel>
            )}
            <NewsList
              route={ROUTE_LIST.TOP_INSTRUMENT}
              effect={newsEffect}
              setEffect={setNewsEffect}
            />
          </div>
        </div>
      </div>
      {!isSP && (
        <DataDescription
          className="panel-data-description"
          children={InstrumentDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
